module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', [(_vm.products && (Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(_vm.products.length))]), _vm._v(" product(s) in your shop")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Stock: ")]), _vm._v(_vm._s(product.product_items[0].product_item_quantity))])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _c('div', [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1,2em"
    }
  }, [(_vm.categories && (Object.keys(_vm.categories).length == 0)) ? _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/newcategory"
    }
  }, [_vm._v("Add New Category to add products")])]) : _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "href": "/account/business/categories"
    }
  }, [_vm._v("Add New Product")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "color": "#e94b4b"
    }
  }, [_vm._v("You have not added any Product yet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4251edba"}!./src/pages/Account/Sellpoint/Products/template.html
// module id = 575
// module chunks = 0